<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="card">
            <v-card-text>
                <template>
                    <v-data-table :headers="table_headers" :items="examlearnerlist" class="elevation-1 table-data" :search="search" :expanded.sync="expanded" :single-expand="singleExpand" show-expand>
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <!-- <v-toolbar-title>Student Data</v-toolbar-title> -->

                                <!-- <v-divider class="mx-10" inset vertical></v-divider> -->
                                <!-- <v-icon class="reload pl-3" v-on="on" color="black" @click="refreshTable"
              >mdi-refresh-circle</v-icon > -->
                                <div style="text-align: center;">
                                    <div>
                                        <span class="refresh">Refresh Live data</span>
                                    </div>
                                    <div>
                                        <v-icon style="font-size: 25px; color: #5cbbf6;" @click="refreshTable">mdi-refresh-circle</v-icon>
                                    </div>
                                </div>
                                <v-spacer></v-spacer>
                                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                                <span style="width: 20px;"></span>
                                <v-spacer></v-spacer>
                                <v-switch v-model="singleExpand" label="Single expand" class="mt-2"></v-switch>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.identity="{ item }">
                            <i class="mdi mdi-eye eye" style="font-size: 30px; color: #5cbbf6;" @click="getIdentity(item)"></i>
                        </template>
                        <template v-slot:item.log="{ item }">
                            <i class="mdi mdi-eye eye" style="text-align: center; color: #5cbbf6; font-size: 30px;" @click="viewAllPhoto(item)"></i>
                        </template>
                        <!-- <template v-slot:item.proctoringpercentage="{ item }">
                            {{ item.proctoringpercentage }}%
                        </template> -->
                        <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length" style="padding-left: 30px;">
                                <v-row>
                                    <v-col cols="12" lg="4">
                                        <!-- <v-row> -->
                                        <template>
                                            <v-simple-table >
                                                <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th class="text-left">Extra Time (in minutes)</th>
                                                            <th v-if="item.conferencing_link !='NA'" class="text-left">Video Conferencing Link</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>{{ item.extra_time_minutes }}</td>
                                                            <td><a v-if="item.conferencing_link !='NA'" v-bind:href="item.conferencing_link" target="_blank">{{item.conferencing_link}}</a></td>
                                                        </tr>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                        </template>
                                        <!-- </v-row> -->
                                    </v-col>
                                </v-row>
                            </td>
                        </template>
                    </v-data-table>
                </template>
            </v-card-text>
        </v-card>
        <template>
            <div class="text-center">
                <v-dialog v-model="dialog_photo" width="500">
                    <v-card>
                        <v-card-title class="heading">
                            <span>Student Photo</span>
                        </v-card-title>
                        <br />
                        <center>
                            <span v-if="this.photo_url != '-'">
                                <img v-bind:src="this.photo_url" height="250px" width="250px" />
                            </span>
                            <span v-else>
                                <v-card-text style="text-align: center; padding: 20px; color: red; font-size: 16px;">Student Photo Not Available!</v-card-text>
                            </span>
                        </center>
                        <v-card-actions style="justify-content: center;">
                            <v-btn class="button" @click="dialog_photo = false">OK</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>
         <v-row justify="center">
            <v-dialog v-model="dialog_zooimg" persistent max-width="600px">
                <v-card>
                    <br />
                    <v-card-title>
                        <span class="headline">Image Pre-View</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <img class="question-img rounded w-100 d-block imgs-preview" :src="img_url" />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-row>
                        <v-btn color="error" class="justify-center" rounded @click="dialog_zooimg = false">Close</v-btn>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <template>
            <v-row justify="center">
                <v-dialog v-model="proctoring_log" fullscreen hide-overlay transition="dialog-bottom-transition">
                    <v-card>
                        <v-toolbar class="all-pic">
                            <v-btn icon dark @click="proctoring_log = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title>Proctoring Logs</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                                <v-btn dark text @click="proctoring_log = false">Close</v-btn>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-row>
                            <v-data-table :headers="headers1" :items="proctorloglist" :search="search">
                                <template v-slot:item.isweirdsounddected="{ item }">
                                    <span v-if="item.isweirdsounddected == true">
                                        <v-icon class="mr-2" color="success">mdi-check-circle-outline</v-icon>
                                    </span>
                                    <span v-else>
                                        <v-icon class="mr-2" color="error">mdi-close-circle-outline</v-icon>
                                    </span>
                                </template>
                                <template v-slot:item.isimageattached="{ item }">
                                    <span v-if="item.isimageattached == true">
                                        <v-icon class="mr-2" color="success">mdi-check-circle-outline</v-icon>
                                    </span>
                                    <span v-else>
                                        <v-icon class="mr-2" color="error">mdi-close-circle-outline</v-icon>
                                    </span>
                                </template>
                                <template v-slot:item.isoutofframedetected="{ item }">
                                    <span v-if="item.isoutofframedetected == true">
                                        <v-icon class="mr-2" color="success">mdi-check-circle-outline</v-icon>
                                    </span>
                                    <span v-else>
                                        <v-icon class="mr-2" color="error">mdi-close-circle-outline</v-icon>
                                    </span>
                                </template>
                                <template v-slot:item.ismorethanonepersondetected="{ item }">
                                    <span v-if="item.ismorethanonepersondetected == true">
                                        <v-icon class="mr-2" color="success">mdi-check-circle-outline</v-icon>
                                    </span>
                                    <span v-else>
                                        <v-icon class="mr-2" color="error">mdi-close-circle-outline</v-icon>
                                    </span>
                                </template>
                                <template v-slot:item.isabnormal="{ item }">
                                    <span v-if="item.isabnormal == true">
                                        <v-icon class="mr-2" color="success">mdi-check-circle-outline</v-icon>
                                    </span>
                                    <span v-else>
                                        <v-icon class="mr-2" color="error">mdi-close-circle-outline</v-icon>
                                    </span>
                                </template>
                                <template v-slot:item.photopath="{ item }">
                                    <span v-if="item.photopath">
                                        <img v-bind:src="item.photopath"  @click="zooimg(item.photopath)"  height="100px" width="100px" />
                                    </span>
                                </template>
                            </v-data-table>
                            <!-- <v-col sm="2" v-for="ph in photoPath" :key="ph">
                     <img v-bind:src="ph" height="100px" width="100px" />
                     </v-col> -->
                        </v-row>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css";
    export default {
        data: () => ({
            dialog_zooimg: false,
            img_url: "",
            proctor_id: null,
            color: "",
            snackbar: false,
            snackbar_msg: "",
            search: "",
            examlearnerlist: [],
            photo_url: null,
            dialog_photo: false,
            proctoring_log: false,
            proctorloglist: "",
            singleExpand: false,
            table_headers: [
                { text: "Sr.No.", value: "srno" },
                { text: "Student Name", value: "studname" },
                { text: "Start Time", value: "started_at" },
                { text: "End Time", value: "exam_end_time" },
                { text: "Student End Time", value: "student_end_time" },
                { text: "IP Address", value: "ipaddress" },
                { text: "Remaining Time(minutes)", value: "remaining_time" },
                { text: "Candidate Identity", value: "identity" },
                { text: "View Proctoring Logs", value: "log" },
                // { text: "Proctoring%", value: "proctoringpercentage" },
            ],
            headers1: [
                { text: "Sr.No.", value: "srno" },
                { text: "Proctoring Type", value: "proctortype" },
                { text: "Captured Date", value: "captureddatetime" },
                { text: "Is Weird Sound Detected", value: "isweirdsounddected" },
                { text: "Is Image Matched", value: "isimageattached" },
                { text: "Is Out Of Frame Detceted", value: "isoutofframedetected" },
                {
                    text: "Is More Than 1 Person Detected",
                    value: "ismorethanonepersondetected",
                },
                { text: "Is Abnormal", value: "isabnormal" },
                { text: "Photo", value: "photopath" },
            ],
        }),
        mounted() {
            this.onload();
        },
        methods: {
            zooimg(url_img) {
                this.img_url = url_img;
                this.dialog_zooimg = true;
            },
            onload() {
                if (this.$store.getters.coe_proctor_dashboard_id == null) {
                    this.$router.push({ name: "proctor-monitoring" });
                } else {
                    this.proctor_id = this.$store.getters.coe_proctor_dashboard_id;
                    this.getDetails();
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getDetails() {
                console.log("Inside onLoad:");
                const data = {
                    proctor_id: this.proctor_id,
                };
                console.log("data: " + data.proctor_id);
                axios
                    .post("COE/COEProctorDashboardHome", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.examlearnerlist = res.data.lesummary_data;
                            window.console.log("res.data.lesummary_data: " + res.data.lesummary_data);
                            //alert(res.data.stud_catlist)
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            refreshTable() {
                this.getDetails();
            },
            getIdentity(item) {
                const data = {
                    lesid: item.id,
                };
                axios
                    .post("ProctorLiveDashboard/getIdentity", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.photo_url = res.data.temp.photopath;
                            this.dialog_photo = true;
                        } else {
                            this.showSnackbar("#b71c1c", "Exam has not been started yet!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {});
            },
            viewAllPhoto(item) {
                const data = {
                    lesid: item.id,
                };
                axios
                    .post("ProctorLiveDashboard/getproctorlogs", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.proctorloglist = res.data.temp;
                            this.proctoring_log = true;
                        } else {
                            this.showSnackbar("#b71c1c", "Exam Is Not Started Yet....");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {});
            },
        },
    };
</script>

<style scoped>
    .refresh {
        font-size: 11px;
        color: green;
    }
    .card {
        border: 2px solid hsla(190, 99%, 30%, 1) !important;
    }
    .all-pic {
        background-color: hsla(190, 99%, 30%, 1) !important;
        color: white;
    }
</style>
